import * as ActionTypes from './../constants';
import axios from 'axios'; 
import {baseUrl } from '../index'; 
import { getUserToken } from './../getUserToken';

 

export default function (state = {}, action){

    switch(action.type){
        case ActionTypes.REQUEST_TEST_SERIES_LIST:
        return {
            ...state,
            loading:true,
            error:false,
            errorInfo:null,
            response:null
        }

        case ActionTypes.RECEIVED_TEST_SERIES_LIST:
        return {
            ...state,
            loading:false,
            response:action.res,
            error:false,
            errorInfo:null
        }

        case ActionTypes.ERROR_TEST_SERIES_LIST:
        return {
            ...state,
            loading:false,
            error:true,
            errorInfo:action.err,
            response:null
        }

        case ActionTypes.CLEAR_TEST_SERIES_LIST:
        return {}
        default: return state;
    }

}

const dispatchRequestTestSeriesList  = (data) => ({
    type: ActionTypes.REQUEST_TEST_SERIES_LIST,
    data
});

const dispatchReceivedTestSeriesList  = (res) => ({
    type: ActionTypes.RECEIVED_TEST_SERIES_LIST,
    res
});

const dispatchErrorTestSeriesList  = (err) => ({
    type: ActionTypes.ERROR_TEST_SERIES_LIST,
    err
});

const dispatchClearTestSeriesList  = () => ({
    type: ActionTypes.CLEAR_TEST_SERIES_LIST,
    
});


export const getTestSeriesList = () => dispatch => {
    dispatch(dispatchRequestTestSeriesList());
    getUserToken()
    .then(authKey => {
        const options = {
            method: 'post',
            url: `${baseUrl}/api/mockserieslist`,
            headers: {
                'Authorization': `Bearer ${authKey}`
            }
        }
        return axios(options)
              .then(res => {
                  console.log(res);
                  dispatch(dispatchReceivedTestSeriesList(res));
              })
              .catch(err => dispatch(dispatchErrorTestSeriesList(err)))
    });

}

export const clearTestSeriesList = () => dispatch => {
    dispatch(dispatchClearTestSeriesList())
}